import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_META, findRouteByPath } from "pages/routes/utils";

/**
 * What the navigation that reached this page put in its state, if anything.
 *
 * `useLocation()` types state `any`, and react-router defaults it to null, so a
 * direct visit arrives with none. A caller names what it sent and still has to
 * handle its absence.
 */
export function useLocationState<TState>(): TState | null {
  return useLocation().state as TState | null;
}

/** The current route's metadata, or the defaults for a path that matches none. */
export function useRouteMeta() {
  const { pathname } = useLocation();
  const currentRoute = useMemo(() => findRouteByPath(pathname), [pathname]);
  return currentRoute?.meta ?? DEFAULT_META;
}
